import React from 'react';

export const HOTexts = {
  title: {
      ko: (
        <>
          랜섬웨어 자동 복구 솔루션
        </>
      ),
      en: (
        <>
          Ransomware Automatic Recovery Solution
        </>
      )
  },
  subtitle: {
      ko: (
        <>
          Halcyon
        </>
      ),
      en: (
        <>
          Halcyon
        </>
      )
  }
};

export const outlineTexts = {
  title: {
      ko: (<>랜섬웨어가 여전히 문제인 이유</>),
      en: (<>Why Ransomware is Still a Problem</>),
  },
  group: {
    title: {
      ko: (<>조직에는 여전히 보안 격차가 있습니다</>),
      en: (<>Organizations Still Have Security Gaps</>)
    },
    message: {
      ko: (<>공격자는 패치되지 않은 시스템, 알려진 취약점, 취약한 자격 증명, 잘못된 구성을 쉽게 악용하여
          사용자 환경에 침투할 수 있습니다</>),
      en: (<>Attackers can easily exploit unpatched systems, known vulnerabilities, weak credentials, 
          and misconfigurations to infiltrate user environments</>)
    },
  },
  business: {
    title: {
      ko: (<>랜섬웨어 사업이 붐을 이루고 있습니다</>),
      en: (<>Ransomware Business is Booming</>)
    },
    message: {
      ko: (<>랜섬웨어 서비스(RaaS) 플랫폼을 통해 공격자는 날로 수와 정교함이 늘어나고 있으며,
          사실상 아무런 손해 없이 막대한 수익을 올리고 있습니다.</>),
      en: (<>Through Ransomware as a Service (RaaS) platforms, attackers are increasing in number and sophistication,
          reaping enormous profits with virtually no consequences.</>)
    },
  },
  duress: {
    title: {
      ko: (<>이중 협박 전술로 위험도가 높아집니다</>),
      en: (<>Double Extortion Tactics Increase Risk</>)
    },
    message: {
      ko: (<>공격자는 더 이상 단순히 데이터를 암호화하는 데 그치지 않습니다. 먼저 데이터를 훔친 후
             몸값을 지불하지 않으면 민감한 데이터를 유출하겠다고 위협합니다.</>),
      en: (<>Attackers no longer just encrypt your data. 
             They steal it first and threaten to leak your sensitive data if the ransom isn’t paid.</>),
    },
  },


};

export const statisticsTexts = {
  title: {
      ko: (<>랜섬웨어 통계</>),
      en: (<>Ransomware Statistics</>),
  },
  ransomwareCostTab: {
    title: {
      ko: (<>랜섬웨어 공격의 평균 비용은 얼마나 지불할까요?</>),
      en: (<>What is the average cost of a ransomware attack?</>)
    },
    message: {
      ko: (<>랜섬웨어는 몸값 지불 자체를 훨씬 뛰어넘는 비용을 초래합니다. 협상, 사고대응, 법률 비용, 데이터 복구, 브랜드 손상 등
          모든 비용이 소기업과 대기업 모두에게 수백만 달러의 손실을 초래합니다. 이 수치는 몸값 지불 또는 거부가
          기업을 종종 손해 보는 상황에 빠뜨리는 이유를 잘 보여줍니다.</>),
      en: (<>All costs can result in millions of dollars in losses for both small and large businesses. 
          This figure illustrates how paying or refusing to pay the ransom often puts companies in a losing situation.</>)
    },
    totalcostBox: {
      title: {
        ko: (<>2024</>),
        en: (<>2024</>)
      },
      value: {
        ko: (<>$4,880,000</>),
        en: (<>$4,880,000</>)
      },
      message: {
        ko: (<>랜섬웨어 침해 평균 총 비용</>),
        en: (<>Average Total Cost of Ransomware Breaches</>)
      },
      link: {
        ko: (<>출처:IBM*2024년 데이터 침해 비용</>),
        en: (<>Source: IBM*2024 Data Breach Costs</>)
      }
    },
    victimratioBox: {
      title: {
        ko: (<>2024</>),
        en: (<>2024</>)
      },
      value: {
        ko: (<>25%</>),
        en: (<>25%</>)
      },
      message: {
        ko: (<>몸값 지불한 피해자 비율</>),
        en: (<>Ransomware Victim Payment Rate</>)
      },
      link: {
        ko: (<>출처:Coveware 2024년 4분기 보고서</>),
        en: (<>Source: Coveware 2024 Q4 Report</>)
      }
    },
    costrangeBox: {
      title: {
        ko: (<>2024</>),
        en: (<>2024</>)
      },
      value1: {
        ko: (<>$120K</>),
        en: (<>$120K</>)
      },
      value2: {
        ko: (<>$1.24M</>),
        en: (<>$1.24M</>)
      },
      message: {
        ko: (<>중소기업 피해 비용 범위</>),
        en: (<>Small Business Victim Cost Range</>)
      },
      link: {
        ko: (<>출처:IBM - 2024년 데이터 침해 비용</>),
        en: (<>Source: IBM - Cost of a Data Breach 2024</>)
      }
    },
    averagepaidBox: {
      title: {
        ko: (<>2024</>),
        en: (<>2024</>)
      },
      value: {
        ko: (<>$550,000</>),
        en: (<>$550,000</>)
      },
      message: {
        ko: (<>지불한 평균 몸값</>),
        en: (<>Average Ransom Paid</>)
      },
      link: {
        ko: (<>출처:Coveware 2024년 4분기 보고서</>),
        en: (<>Source: Coveware 2024 Q4 Report</>)
      }
    },
    averagebodypriceBox: {
      title: {
        ko: (<>2024</>),
        en: (<>2024</>)
      },
      value: {
        ko: (<>$3,500,000</>),
        en: (<>$3,500,000</>)
      },
      message: {
        ko: (<>요구한 평균 몸값</>),
        en: (<>Average Ransom Demanded</>)
      },
      link: {
        ko: (<>출처:Comparitech 2024 보고서</>),
        en: (<>Source: Comparitech 2024 Report</>)
      }
    },
    paymentComparisonBox: {
      title: {
        ko: (<>2024</>),
        en: (<>2024</>)
      },
      value1: {
        ko: (<>$4.49M</>),
        en: (<>$4.49M</>)
      },
      value2: {
        ko: (<>$5.12M</>),
        en: (<>$5.12M</>)
      },
      message: {
        ko: (<>지불된 비용 대 거부된 비용</>),
        en: (<>Paid vs. Refused Ransom</>)
      },
      link: {
        ko: (<>출처:IBM - 2024년 데이터 침해 비용</>),
        en: (<>Source: IBM - 2024 Data Breach Costs</>)
      }
    },

  },


};

export const ransomwareTexts = {
  title: {
      ko: (<>Halcyon의 랜섬웨어 방어</>),
      en: (<>Halcyon Ransomware Defense</>),
  },

};



export const attackTexts = {
  title: {
      ko: (<>Halcyon 랜섬웨어 공격 체인 작동 방식</>),
      en: (<>How Ransomware Attack Chains Work</>),
  },
  initialaccess: {
    title: {
      ko: (<>초기 접근</>),
      en: (<>Initial Access</>)
    },
    message: {
      ko: (<>Halcyon은 공격자가 악성 실행 파일, 무차별 대입공격 시도 또는 명령 및 제어(C2) 
           인프라를 사용하여 사용자 환경에 엑세스하는 경우를 감지합니다.</>),
      en: (<>Halcyon detects when attackers use malicious executables, brute-force attack attempts, 
           or command and control (C2) infrastructure to gain access to user environments.</>)
    },
  },
  remoteaccess: {
    title: {
      ko: (<>원격 접근</>),
      en: (<>Remote Access</>)
    },
    message: {
      ko: (<>초기 접근 권한을 획득한 후, 공격자는 일반적으로 원격 접근 도구를 사용하여 공격을 더욱 효과적으로 수행합니다.
           Halcyon은 이러한 활동을 감지하고 즉각적인 조사를 위한 알람을 생성합니다.</>),
      en: (<>After gaining initial access, attackers typically use remote access tools to carry out their attacks more effectively.
           Halcyon detects these activities and generates alerts for immediate investigation.</>)
    },
  },
  privilege: {
    title: {
      ko: (<>권한 상승</>),
      en: (<>Privilege Escalation</>)
    },
    message: {
      ko: (<>Halcyon은 악성 실행 파일이나 취약한 커널 드라이버를 사용하여 공격자가
           사용자 권한을 확대하려는 시도를 경고하고 방해합니다.</>),
      en: (<>Halcyon warns and interferes with attempts by attackers to escalate 
           user privileges using malicious executables or vulnerable kernel drivers.</>)
    },
  },
  environmentenumeration: {
    title: {
      ko: (<>환경 열거</>),
      en: (<>Environment Enumeration</>)
    },
    message: {
      ko: (<>Halcyon은 공격자가 정찰 및 정보 수집을 위해 사용자 환경을 열거하려고 할 때 이를
           식별하여 궁극적으로 공격을 더욱 효과적으로 만듭니다.</>),
      en: (<>Halcyon identifies when attackers attempt to enumerate user environments for reconnaissance and 
           information gathering, ultimately making attacks more effective.</>)
    },
  },
  credentialharvesting: {
    title: {
      ko: (<>자격 증명 수집</>),
      en: (<>Credential Harvesting</>)
    },
    message: {
      ko: (<>Halcyon은 공격자가 유효한 사용자 자격 증명을 수집하는 방법을 이해하고,
           공격자의 행동을 자동으로 탐지하고 차단합니다.</>),
      en: (<>Halcyon understands how attackers collect valid user credentials and 
           automatically detects and blocks their actions.</>)
    },
  },
  lateralmovement: {
    title: {
      ko: (<>측면 이동</>),
      en: (<>Lateral Movement</>)
    },
    message: {
      ko: (<>Halcyon은 공격자가 사용자 환경 내에서 측면 이동을 시도할 때 이를 감지하고 차단합니다.
           예를들어, RMM도구를 사용하여 환경 내 시스템에 접속을 시도할 경우, Halcyon은 해당 진행을 차단할 수 있습니다.</>),
      en: (<>Halcyon detects and blocks attempts by attackers to move laterally within user environments.
           For example, if an attacker tries to access systems within the environment using RMM tools, Halcyon can block that activity.</>)
    },
  },
  securitybypass: {
    title: {
      ko: (<>보안 우회</>),
      en: (<>Security Bypass</>)
    },
    message: {
      ko: (<>Halcyon은 EDR Last Gasp 및 Tamper Guard와 같은 고유의 기능을 사용하여 공격자가
           실시간으로 보안 제품을 우회하고 비활성화하려는 시도를 차단합니다.</>),
      en: (<>Halcyon uses unique features such as EDR Last Gasp and Tamper Guard to block attempts by attackers
           to bypass and disable security products in real-time.</>)
    },
  },
  dataexfiltration: {
    title: {
      ko: (<>데이터 유출</>),
      en: (<>Data Exfiltration</>)
    },
    message: {
      ko: (<>Halcyon 데이터 유출 방지(DXP)는 다른 보안 도구로는 아직 잡히지 않은 공격자가
           데이터를 훔치려는 시도를 조기에 경고하는 시스템 역할을 합니다.</>),
      en: (<>Halcyon Data Exfiltration Prevention (DXP) serves as a system 
           that provides early warnings of attempts by attackers to steal data 
           that have not yet been detected by other security tools.</>)
    },
  },
  backupdestruction: {
    title: {
      ko: (<>백업 파괴</>),
      en: (<>Backup Destruction</>)
    },
    message: {
      ko: (<>Halcyon은 악성 실행 파일, 무차별 대입 공격 또는 명령 및 제어(C2) 인프라를 사용하여
           사용자 환경에 대한 초기 액세스를 시도하는 공격자를 감지하고 방해할 수 있습니다.</>),
      en: (<>Halcyon can detect and thwart attackers attempting to gain initial access to user environments using
           malicious executables, brute-force attacks, or command and control (C2) infrastructure.</>)
    },
  },
  dataencryption: {
    title: {
      ko: (<>데이터 암호화</>),
      en: (<>Data Encryption</>)
    },
    message: {
      ko: (<>Halcyon은 캡처한 키 자료를 사용하여 데이터를 해독하는 기능을 갖추고 있어
           랜섬웨어 공격중에 데이터가 암호화된 경우 대체 복구 경로를 제공합니다.</>),
      en: (<>Halcyon provides an alternative recovery path in the event 
           that data is encrypted during a ransomware attack by utilizing captured key material to decrypt the data.</>)
    },
  },

};

export const platformTexts = {
  title: {
      ko: (<>Halcyon 지원 플랫폼</>),
      en: (<>Halcyon Supported Platforms</>),
  },
  windowsserver: {
    ko: (<>Windows Server</>),
    en: (<>Windows Server</>),
    ws2012x64: {
      ko: (<>Windows Server 2012 (64-bit)</>),
      en: (<>Windows Server 2012 (64-bit)</>)
    },
    ws2016: {
      ko: (<>Windows Server 2016</>),
      en: (<>Windows Server 2016</>)
    },
    ws2019: {
      ko: (<>Windows Server 2019</>),
      en: (<>Windows Server 2019</>)
    },
    ws2022: {
      ko: (<>Windows Server 2022</>),
      en: (<>Windows Server 2022</>)
    },
  },
  windows: {
    ko: (<>Windows</>),
    en: (<>Windows</>),
    w10: {
      ko: (<>Windows 10</>),
      en: (<>Windows 10</>)
    },
    w11: {
      ko: (<>Windows 11</>),
      en: (<>Windows 11</>)
    }
  },
  linux: {
    ko: (<>Linux</>),
    en: (<>Linux</>),
    rhel79: {
      ko: (<>RHEL 7.9 (eBPF 지원 안함)</>),
      en: (<>RHEL 7.9 (eBPF not supported)</>)
    },
    rhel89: {
      ko: (<>RHEL 8 및 9</>),
      en: (<>RHEL 8 and 9</>)
    },
    ubuntu2224: {
      ko: (<>Ubuntu 22.04, 24.04 LTS</>),
      en: (<>Ubuntu 22.04 and 24.04 LTS</>)
    },
    rhelbin: {
      ko: (<>RHEL 바이너리 호환 배포판 (오라클 리눅스, 알마 리눅스, 로키 리눅스)</>),
      en: (<>RHEL binary-compatible distributions (Oracle Linux, AlmaLinux, Rocky Linux)</>)
    },
    debian: {
      ko: (<>Debian 11 및 12</>),
      en: (<>Debian 11 and 12</>)
    },
    aws2: {
      ko: (<>AWS Linux 2(eBPF는 지원 안함)</>),
      en: (<>AWS Linux 2 (eBPF not supported)</>)
    },
    aws: {
      ko: (<>AWS Linux 2023</>),
      en: (<>AWS Linux 2023</>)
    }
  },
  etc: {
    ko: (<>OS 추가 지원 예정</>),
    en: (<>OS support coming soon</>)
  }
};

